import React from "react";
import Form from "../../Shared/components/Form";
import Hero from "../../Shared/components/Hero";
import InputWithSubmit from "../../Shared/components/InputWithSubmit";

const Lastname = ({ value, onChange, onSubmit }) => {
  return (
    <Form id="last-name" onSubmit={onSubmit}>
      <Hero>Quel est votre nom ?</Hero>
      <InputWithSubmit
        id="last-name"
        autoComplete="off"
        name="last-name"
        type="text"
        required
        className="w-1/2"
        value={value}
        onChange={onChange}
      />
      <div className="h-16" />
    </Form>
  );
};

export default Lastname;
